var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column height-100"},[_c('Header'),_c('div',{staticClass:"d-flex flex-column flex-1 dot-grid-background main-container"},[_vm._t("main")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }